import React, { useContext, useState } from 'react';
import { Modal, Button, Card } from "react-bootstrap";
import { CardContent } from "@material-ui/core";
import { LocationContext } from '../../../CustomHelper/Helper';


function EventPromo() {
    const { regPromo, setRegPromo } = useContext(LocationContext);
    console.log('reg promo video--', regPromo)

    const [show, setShow] = useState(true);
    const handleClose = () => {
        setShow(false);
        setRegPromo({ ...regPromo, isReg: false })

    }
    const handleShow = () => setShow(true);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <Modal.Body>
                <Card style={{ backgroundColor: "#25272b", borderColor: 'gold', borderWidth: '10px' }} sx={{ minWidth: 500 }} className="shadow-sm p-3 mb-5 rounded">
                    <div
                        onClick={handleClose}
                        className="d-flex justify-content-end p-2"
                    >
                        <div className="closeNotificationDrop text-center">X</div>
                    </div>
                    <CardContent>
                        <p className='text-light p-4 h4'>
                            {regPromo?.promoMessage?.message}(HSS{regPromo.phone}) {regPromo?.promoMessage?.message_ex}
                        </p>
                    </CardContent>
                    <div className='d-flex justify-content-center'>
                        <Button type="button" className='btn btn-warning p-2' onClick={handleClose}>OK</Button>
                    </div>
                </Card>
            </Modal.Body>
        </Modal>
    )
}

export default EventPromo